export default class PermissionsError extends Error {
  constructor() {
    super(
      'There was a problem authenticating. Please check permissions.',
    );
  }
}
